import axios from "axios";
import { baseURL } from "../Environment";

const ApiRequest = axios.create({
  baseURL,
});

ApiRequest.interceptors.request.use((config) => {
  const userId = localStorage.getItem("user_id");
  if (userId) {
    config.headers["user-id"] = userId;
  }
  return config;
});

ApiRequest.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export default ApiRequest;
